// Snakes & Ladders — classic 10x10 board. Dependency-free (client + server).

export const SNL_N = 10;
export const SNL_GOAL = 100;

/** foot square -> top square (climb up) */
export const SNL_LADDERS: Record<number, number> = {
  1: 38, 4: 14, 9: 31, 21: 42, 28: 84, 36: 44, 51: 67, 71: 91, 80: 100,
};
/** head square -> tail square (slide down) */
export const SNL_SNAKES: Record<number, number> = {
  16: 6, 47: 26, 49: 11, 56: 53, 62: 19, 64: 60, 87: 24, 93: 73, 95: 75, 98: 78,
};
export const SNL_CHUTES: Record<number, number> = { ...SNL_LADDERS, ...SNL_SNAKES };

/** square 1..100 -> grid {col,row}; row 0 is the BOTTOM, path snakes left/right */
export function snlCell(n: number): { col: number; row: number } {
  const i = Math.max(1, Math.min(SNL_GOAL, n)) - 1;
  const row = Math.floor(i / SNL_N);
  const inRow = i % SNL_N;
  const col = row % 2 === 0 ? inRow : SNL_N - 1 - inRow;
  return { col, row };
}
